import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import { toast } from 'react-toastify';
import useManageWeeklyShip from '../weeklyShip/useManageWeeklyShip';
import CircularProgress from '@mui/material/CircularProgress';


const TrackingMatch = () => {
  const columnDefs = [
    { headerName: 'เลขกล่อง', field: 'boxNo', flex: 1 },
    { headerName: 'มาจากรอบเรือเก่า', field: 'oldShipDate', flex: 1 },
    { headerName: 'วิธีการส่ง', field: 'deliveryMethod', flex: 1 },
    { headerName: 'ขนส่งไทย', field: 'courierTh', flex: 1 },
    { headerName: 'เลขพัสดุไทย', field: 'trackingTh', flex: 1 },
    { headerName: 'ค่าส่งในไทย', field: 'deliveryFeeTh', flex: 1 },
    // ... add more columns as required, and remember to set flex: 1
  ];

  const [rowData, setRowData] = useState([]);
  const [shipDate, setShipDate] = useState('');
  const [shipDateId, setShipDateId] = useState('');
  const [shipDateText, setShipDateText] = useState('');
  const [dataShipDate, setDataShipDate] = useState('');
  const [pasteBoxNo, setPasteBoxNo] = useState('');
  const [pasteSmileNote, setPasteSmileNote] = useState('');
  const [pasteDeliveryMethod, setPasteDeliveryMethod] = useState('');
  const [pasteTrackingTh, setPasteTrackingTh] = useState('');
  const [pasteTotalAmount, setPasteTotalAmout] = useState('');
  const [issues, setIssues] = useState([]);

  const {updateOrderTrackingTh, error, isLoading} = useManageWeeklyShip();

  const getCourierFromTracking = (tracking) => {
    if (tracking.endsWith("RTT")) {
      return "RTT";
    } else if (tracking.endsWith("TH")) {
      return "EMS";
    } else if (/^\d+$/.test(tracking)) { // Check if the tracking number is all numeric
      switch (tracking.length) {
        case 14: // Assuming 14 digits is the length for BEST based on the example
          return "BEST";
        case 16: // Assuming 16 digits is the length for DHL based on the example
          return "DHL";
        default:
          return null;
      }
    } else {
      return null;
    }
  };
  
  const parseShipmentDateFromNote = (note) => {
    if(note === null){
      return null
    }
    // Keywords to look for in the note
    const keywords = ['เพิ่มใหม่', 'รอบเรือ'];
    // Check if the note contains any of the keywords
    const containsKeywords = keywords.some(keyword => note.includes(keyword));
    
    if (!containsKeywords) {
      return null; // Keywords not found in the note, return null or handle as needed
    }
  
    // Regular expression to match dates in the note (e.g., 28/1 or 28/01)
    const dateRegex = /(\d{1,2})\/(\d{1,2})/;
    const match = note.match(dateRegex);
  
    if (!match) {
      return null; // Date not found in the note, return null or handle as needed
    }
  
    // Extract day and month from the matched date
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
  
    // Determine the year based on the current date and the extracted month and day
    const currentDate = new Date();
    let year = currentDate.getFullYear();
  
    // Check if the extracted date might refer to the previous year
    if (month > currentDate.getMonth() + 1) {
      year--;
    }
  
    // Construct and format the shipment date
    const shipmentDate = new Date(year, month - 1, day); // JavaScript months are 0-indexed
    const formattedShipmentDate = shipmentDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).replace(/ /g, '-'); // Format: 28-Jan-2024
  
    return formattedShipmentDate;
  }


  const handleLoadClick = async () => {
    if (!shipDate) {
      toast.error("Please select Ship Date First");
      return;
    }
  
    // Split other paste areas directly as they are
    const boxNoArray = pasteBoxNo.split("\n");
    const deliveryMethodArray = pasteDeliveryMethod.split("\n");
    const trackingThArray = pasteTrackingTh.split("\n");
    const totalAmountArray = pasteTotalAmount.split("\n");
  
    // Function to escape newlines within quotes for smile note
    const escapedPasteSmileNote = pasteSmileNote.replace(/"([^"]*)"/g, (match, p1) => {
      return `"${p1.replace(/\n/g, '\\n')}"`;
    });
  
    // Split the escaped smile note text into an array
    const smileNoteArray = escapedPasteSmileNote.split("\n").map(note =>
      note.replace(/\\n/g, '\n') // Unescape the placeholders back to actual newlines
    );
  
    // Check if all arrays have the same length
    if (boxNoArray.length === smileNoteArray.length && boxNoArray.length === trackingThArray.length && boxNoArray.length === totalAmountArray.length && boxNoArray.length === deliveryMethodArray.length) {
      const combinedArray = boxNoArray.map((boxNo, index) => ({
        boxNo,
        courierTh: getCourierFromTracking(trackingThArray[index]),
        oldShipDate: parseShipmentDateFromNote(smileNoteArray[index]),
        deliveryMethod : deliveryMethodArray[index],
        deliveryFeeTh: totalAmountArray[index],
        trackingTh: trackingThArray[index],
      }));
  
      setRowData(combinedArray);
      setDataShipDate(shipDateText);
      setShipDateId(shipDate);
    } else {
      // Handle the error if arrays are not of the same length
      console.error("Arrays are not of the same length.");
      toast.error("Data columns do not match in length. Please check your inputs.");
    }
  };
  
  

  const handleSave = async () => {

    if(rowData.length == 0){
      toast.warning("Please click Load Data first")
    }else{
      const formData = {
        rowData: rowData,
        shipDateId: shipDateId
      }
      console.log(formData)
      const response = await updateOrderTrackingTh(formData)
      console.log(response)
      if(!response){
        toast.error("There is something wrong!!")
      }else if(!Array.isArray(response)){
        toast.success('Update records successfully')
      }
      else{
        const message = response.map((element, index) => (
          <div key={index}>
            {element.boxNo} - {element.error}
            {index < response.length - 1 && <br />}
          </div>
        ));
      
        toast.error(<div>{message}</div>);
      }
      setRowData([])
    }
  }
  
  const handleSelectChange = (e) => {
    setShipDate(e.target.value)
    setShipDateText(e.target.options[e.target.selectedIndex].text)
  }

  useEffect(() => {
    if(error == 'ON CONFLICT DO UPDATE command cannot affect row a second time'){
      toast.error('Duplicate Box No.')
    }else{
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="ag-theme-alpine container mx-auto" style={{ width: '100%' }}>
      <h2 className='text-5xl'>Weekly Ship Tracking Match</h2>
      <h2>แยกกัน paste, order, boxno, trackno, price</h2>
      <div className='grid grid-cols-1 md:grid-cols-6 gap-4'>
        <div>
          <label htmlFor="boxNo" className="block text-sm font-medium text-gray-700 mb-1">เลขกล่อง :</label>
          <textarea
            id="boxNo"
            className='w-full h-32 p-2 border border-gray-300 rounded-md'
            placeholder="เลขกล่อง"
            value={pasteBoxNo}
            onChange={e => setPasteBoxNo(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="deliveryMethod" className="block text-sm font-medium text-gray-700 mb-1">ขนส่ง :</label>
          <textarea
            id="deliveryMethod"
            className='w-full h-32 p-2 border border-gray-300 rounded-md'
            placeholder="ขนส่ง :"
            value={pasteDeliveryMethod}
            onChange={e => setPasteDeliveryMethod(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="smileNote" className="block text-sm font-medium text-gray-700 mb-1">หมายเหตุ Smile :</label>
          <textarea
            id="smileNote"
            className='w-full h-32 p-2 border border-gray-300 rounded-md'
            placeholder="หมายเหตุ Smile"
            value={pasteSmileNote}
            onChange={e => setPasteSmileNote(e.target.value)}
          />
        </div>
        {issues.length > 0 && (
          <div>
            <h3>Issues Found:</h3>
            {issues.map((issue, index) => (
              <p key={index}>{issue.boxNo}: {issue.error}</p>
            ))}
          </div>
        )}
        <div>
          <label htmlFor="trackingTh" className="block text-sm font-medium text-gray-700 mb-1">เลขพัสดุไทย :</label>
          <textarea
            id="trackingTh"
            className='w-full h-32 p-2 border border-gray-300 rounded-md'
            placeholder="เลขพัสดุไทย"
            value={pasteTrackingTh}
            onChange={e => setPasteTrackingTh(e.target.value)}
          />
        </div>

        <div>
          <label htmlFor="totalAmount" className="block text-sm font-medium text-gray-700 mb-1">ยอดเงินรวม :</label>
          <textarea
            id="totalAmount"
            className='w-full h-32 p-2 border border-gray-300 rounded-md'
            placeholder="ยอดเงินรวม"
            value={pasteTotalAmount}
            onChange={e => setPasteTotalAmout(e.target.value)}
          />
        </div>

        <div className='flex flex-col'>
          <div className=''>
            <ShipDateDropdown 
              handleDataChange={handleSelectChange}
              includeDefault={true}
            />
            <button 
              onClick={handleLoadClick}
              className='bg-blue-500 text-white px-3 py-1.5 rounded-md mt-2 mr-3'
            >
              Load Data
            </button>
            <button 
              onClick={handleSave}
              className='bg-green-600 text-white px-3 py-1.5 rounded-md mt-2'
            >
              Save Data
            </button>
            {isLoading && <CircularProgress />} {/* Render spinner when loading */}
          </div>
          {dataShipDate && <div className='mt-auto text-3xl'>รอบเรือ : {dataShipDate}</div>}
        </div>

      </div>

      <div style={{ height: 300, marginTop: '10px' }}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={rowData}
          domLayout='autoHeight'
          defaultColDef={{ resizable: true }}
          // other props
        />
      </div>
    </div>
  );
}

export default TrackingMatch;
